import React, { useState } from 'react';
import { slugify } from "transliteration";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import styles from "../../styles/Select.module.css";
import { Input } from "./Input"; 

interface Option {
  label: string;
  key: string;
}

export const OptionsEditor = ({
  onUpdate,
  initialOptions,
  style,
  inputLabelStyle
}: {
  onUpdate: (options: Option[], isValid: boolean) => void;
  initialOptions?: Option[];
  style?: React.CSSProperties;
  inputLabelStyle?:  React.CSSProperties;
}) => {
  const [duplicateIndexes, setDuplicateIndexes] = useState<number[]>([]);
  const [options, setOptions] = useState<Option[]>(
    initialOptions && initialOptions.length > 0
      ? initialOptions
      : [{ label: "", key: "" }, { label: "", key: "" }]
  );

  const validateOptions = (currentOptions: Option[]) => {
    const labels = currentOptions.map((opt) => opt.label.trim().toLowerCase());
    const duplicates: number[] = [];

    labels.forEach((label, index) => {
      if (label && labels.indexOf(label) !== index) {
        labels.forEach((l, i) => {
          if (l === label) duplicates.push(i);
        });
      }
    });

    const uniqueDuplicates = Array.from(new Set(duplicates));
    setDuplicateIndexes(uniqueDuplicates);
    onUpdate(currentOptions, uniqueDuplicates.length === 0);
  };

  const handleChange = (index: number, value: string) => {
    const newOptions = [...options];
    newOptions[index].label = value;
    newOptions[index].key = slugify(value, { separator: "_" });

    setOptions(newOptions);
    validateOptions(newOptions);
  };

  const removeOption = (index: number) => {
    const filtered = options.filter((_, i) => i !== index);
    setOptions(filtered);
    validateOptions(filtered);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      
      <div style={{ display: 'flex', flexDirection: 'column', ...style }}>
        {options.map((opt, index) => {
          const isDuplicate = duplicateIndexes.includes(index);
          
          return (
            <div key={index} className={styles.rowGroup}>
              <div className={styles.row} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                
                <Input
                  label={`Варіант ${index + 1}`}
                  value={opt.label}
                  placeholder={`Введіть назву варіанту`}
                  onChange={(val) => handleChange(index, val)}
                  error={isDuplicate ? "Такий варіант уже існує" : undefined}
                  isLabelFloating={index === 0 ? true : undefined}
                  style={{ flex: 1 }}
                  labelStyle={inputLabelStyle}
                />

                {options.length > 2 && (
                  <button
                    className={styles.deleteBtn}
                    onClick={() => removeOption(index)}
                    style={{ marginBottom: '9px' }}
                  >
                    ×
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <button
        className={styles.addBtn}
        onClick={() => setOptions([...options, { label: "", key: "" }])}
      >
        <div className={styles.plusIcon}>
          <AddCircleIcon sx={{ height: "40px", width: "40px", color: "#E4ECFF" }} />
        </div>
        <span>Додати ще варіанти</span>
      </button>
    </div>
  );
};